import React, { useEffect, useRef } from 'react';
import { Link } from "react-scroll";

const HeroSection = () => {
  const textAnimItemsRef = useRef([]);
  const animLineRef = useRef(null);
  const textAnimHolderRef = useRef(null);

  useEffect(() => {
    const textAnimItems = textAnimItemsRef.current;
    const animLine = animLineRef.current;
    const textAnimHolder = textAnimHolderRef.current;
    const animIn = 'anim-in';
    const animOut = 'anim-out';
    const lineActiveClass = 'line-active';
    let animNextItem = null;
    let animPrevItem = null;
    let animFirstLoad = false;
    const animDuration = parseInt(textAnimHolder.getAttribute('data-delay')) || 2000; // Default delay 2000ms
    let animCounter = 0;
    let setTimeAnim;
    let setTimeAnimResize;

    const animFunc = () => {
      clearTimeout(setTimeAnim);

      setTimeAnim = setTimeout(() => {
        animFirstLoad = true;

        if (animPrevItem !== null) {
          animPrevItem.classList.add(animOut);
        }

        animNextItem = textAnimItems[animCounter];
        animNextItem.classList.remove(animOut);
        animNextItem.classList.add(animIn);

        animLine.style.width = animNextItem.clientWidth + 'px';
        animLine.classList.add(lineActiveClass);

        animPrevItem = animNextItem;

        if (animCounter === textAnimItems.length - 1) {
          animCounter = 0;
        } else {
          animCounter++;
        }

        animFunc();
      }, animFirstLoad ? animDuration : 100);
    };

    const getHolderWidth = () => {
      const itemsWidth = Array.from(textAnimItems).map(item => item.clientWidth);
      const biggestWidth = Math.max(...itemsWidth) + 'px';
      textAnimHolder.style.width = biggestWidth;
    };

    const resizeHandler = () => {
      clearTimeout(setTimeAnim);
      clearTimeout(setTimeAnimResize);
      getHolderWidth();

      setTimeAnimResize = setTimeout(() => {
        animFunc();
      }, 50);
    };

    animFunc();
    getHolderWidth();

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', resizeHandler);

    return () => {
      clearTimeout(setTimeAnim);
      clearTimeout(setTimeAnimResize);
      window.removeEventListener('resize', resizeHandler);
      window.removeEventListener('orientationchange', resizeHandler);
    };
  }, []);

  return (
    <section className="hero-one position-relative" id="home" style={{ backgroundImage: 'url(assets/images/main-bg.png)', backgroundSize: 'cover', backgroundPosition: 'center center' }}>
      <div className="bg-overlay"></div>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-7 text-center px-0 px-xl-4 mt-5 mt-lg-0 pt-5 pt-lg-0">
            <h5 className="d-inline-block py-1 px-3 rounded text-muted font-secondary">Hi, I'm Manoj Mishra</h5>
            <h1 className="hero-title mb-4 font-secondary">I'm an Expert in
              <div className="position-relative d-inline-block" style={{ marginBottom: '-20px' , marginTop: '20px' }} data-delay="2200" data-words ref={textAnimHolderRef}>
                &nbsp;
                <span className="text-anim-items text-center">
                  <span className="text-anim-item px-2" ref={el => textAnimItemsRef.current[0] = el}><span>Experienced Electronics</span></span>
                  <span className="text-anim-item px-2" ref={el => textAnimItemsRef.current[1] = el}><span>IoT Leader</span></span>
                  <span className="text-anim-item px-2" ref={el => textAnimItemsRef.current[2] = el}><span>IIM Indore Alumnus (CPPM)</span></span>
                </span>
                <span className="anim-line bg-orange" ref={animLineRef}></span>
              </div>
              Development
            </h1>
            <div className="mb-5 mb-lg-0">
              <div className="d-inline-block">
                <Link className="btn btn-primary">Contact Me</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5 mx-auto mt-5">
            <img src="assets/images/1.png" alt="" className="img-fluid ml-lg-5" style={{ marginTop: '50px' }}/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
